// extracted by mini-css-extract-plugin
export default {"container":"NVCandidatesList_container__G4EnO","cardWrapper":"NVCandidatesList_cardWrapper__EFlBw","pulseBorder":"NVCandidatesList_pulseBorder__6hoM5"};